import CookiesSection from './CookiesSection';

export default CookiesSection;